<template>
    <div
        :class="{
            thumbnail: renderType == 'THUMBNAIL',
            'thumbnail-listitem': renderType == 'LIST',
            pointer: addClick,
        }"
        @click="doClick">
        <template v-if="isLoading">
            <loader />
        </template>
        <template v-else>
            <template v-if="renderType == 'LIST'">
                <div class="image" v-if="showPreview && sourceUrl">
                    <div
                        class="image-box"
                        :style="{
                            backgroundImage: `url(${sourceUrl})`,
                        }" />
                </div>

                <span class="icon type" v-else>
                    <!--<iconFiletypes
                        :label="fileType"
                        :colour="iconColor"
                        class="icon-thumb"
                    />-->
                    <font-awesome-icon :icon="faIcon" />
                </span>
                <span class="properties" v-if="properties">
                    <span class="tag mx5-xs" v-for="(prop, i) in properties" :key="`prop_${i}`">
                        {{ prop.value }}
                    </span>
                </span>
                <span class="name">
                    {{ title }}
                </span>

                <slot></slot>
            </template>
            <template v-else-if="renderType == 'THUMBNAIL'">
                <template v-if="showPreview && sourceUrl">
                    <div class="image">
                        <!--IMAGE-->
                        <template v-if="fileType == 'IMAGE'">
                            <img :src="sourceUrl" />
                        </template>

                        <!--VIDEO-->
                        <template v-else-if="fileType == 'VIDEO'">
                            <video preload autoplay="1" muted :src="sourceUrl"></video>
                        </template>

                        <!--PDF-->
                        <template v-else-if="fileType == 'PDF'">
                            <responsiveIframe :src="sourceUrl" />
                        </template>

                        <!--TXT-->
                        <template v-else-if="fileType == 'TXT'">
                            <responsiveIframe :src="sourceUrl" />
                        </template>

                        <!--OTHER-->
                        <template v-else>
                            <!--<iconFiletypes
                            :label="fileType"
                            :colour="iconColor"
                            class="icon-thumb"
                        />-->
                            <span class="icon type">
                                <font-awesome-icon :icon="faIcon" />
                            </span>
                        </template>
                        <span class="properties" v-if="properties">
                            <span class="tag mx5-xs" v-for="(prop, i) in properties" :key="`prop_${i}`">
                                {{ prop.value }}
                            </span>
                        </span>
                    </div>
                </template>
                <template v-else>
                    <span class="icon type">
                        <font-awesome-icon :icon="faIcon" />
                    </span>
                </template>
                <!-- Buttons by slot -->
                <div class="actions">
                    <slot></slot>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import { iconByFiletype, IMAGE, AUDIO, VIDEO, PDF, WORD, PPT, EXCEL } from './../mixins/helpers.js';
import iconFiletypes from './../Icons/iconFiletypes.vue';
import responsiveIframe from './../public/responsiveIframe.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faFilePdf,
    faFileImage,
    faFileWord,
    faFileExcel,
    faFilePowerpoint,
    faFileAudio,
    faFileVideo,
    faFile,
} from '@fortawesome/free-regular-svg-icons';

library.add(faFilePdf);
library.add(faFileImage);
library.add(faFileWord);
library.add(faFileExcel);
library.add(faFilePowerpoint);
library.add(faFileAudio);
library.add(faFileVideo);
library.add(faFile);

export default {
    name: 'DocumentsThumbnail',
    props: {
        data: { type: Object },
        showPreview: { type: Boolean, default: false },
        renderType: { type: String, default: 'THUMBNAIL' },
        addClick: { type: Boolean, default: false },
        showProperties: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    components: {
        iconFiletypes,
        responsiveIframe,
        FontAwesomeIcon,
    },
    data() {
        return {
            isLoading: false,
            type: null,
            sourceUrl: '',
            title: '',

            hasPermission: false,
            IMAGE: IMAGE,
            AUDIO: AUDIO,
            VIDEO: VIDEO,
            PDF: PDF,
            WORD: WORD,
            PPT: PPT,
            EXCEL: EXCEL,
        };
    },
    computed: {
        faIcon() {
            return this.iconByFiletype(this.type);
        },
        iconColor() {
            if (this.fileType === 'WORD') return '#4A90E2';
            if (this.fileType === 'PPT') return '#9b44b8';
            if (this.fileType === 'XLS') return '#5AC877';
            if (this.fileType === 'PDF') return '#FF341F';
            if (this.fileType === 'TXT' || this.fileType === 'CSV') return '#FDB400';

            return '#8b97a4';
        },
        fileType() {
            var result = 'UNK';
            if (this.IMAGE.contentType.includes(this.type)) result = 'IMAGE';
            if (this.AUDIO.contentType.includes(this.type)) result = 'AUDIO';
            if (this.VIDEO.contentType.includes(this.type)) result = 'VIDEO';
            if (this.PDF.contentType.includes(this.type)) result = 'PDF';
            if (this.WORD.contentType.includes(this.type)) result = 'WORD';
            if (this.PPT.contentType.includes(this.type)) result = 'PPT';
            if (this.EXCEL.contentType.includes(this.type)) result = 'XLS';
            if (this.type === 'text/plain') result = 'TXT';
            if (this.type === 'text/csv') result = 'CSV';

            return result;
        },
        properties() {
            var properties = [];
            //set properties: only show the keys based on the prop showProperties
            if (this.showProperties.length > 0 && this.data && this.data.properties) {
                this.showProperties.forEach((key) => {
                    if (this.data.properties[key]) {
                        properties.push({
                            key: key,
                            value: this.data.properties[key],
                        });
                    }
                });
            }
            return properties;
        },
    },
    watch: {
        data() {
            this.handleIniData();
        },
        showProperties() {
            this.handleIniData();
        },
    },
    created() {
        this.handleIniData();
    },
    methods: {
        iconByFiletype,
        async processDocument(document) {
            //FILE-OBJECT
            this.type = document.contentType;

            //set title
            this.title = document.fileName;
            if (document?.properties?.title) {
                this.title = document.properties.title;
            }

            //set source if needed
            if (this.showPreview) {
                if (document.parentIds && document.parentIds[0]) {
                    if (this.fileType == 'IMAGE') {
                        this.sourceUrl =
                            this.$config.env.PROCESS_API_URL +
                            `api/node/${document.parentIds[0]}/files/${document.fileId}/download`;
                    }
                    if (this.fileType == 'PDF') {
                        this.isLoading = true;
                        let response = await this.$store.dispatch('DOWNLOAD_DOCUMENT', {
                            nodeId: document.parentIds[0],
                            fileId: document.fileId,
                        });
                        this.sourceUrl = window.URL.createObjectURL(response.data);
                        this.isLoading = false;
                    }
                    if (this.fileType == 'TXT') {
                        this.isLoading = true;
                        let response = await this.$store.dispatch('DOWNLOAD_DOCUMENT', {
                            nodeId: document.parentIds[0],
                            fileId: document.fileId,
                        });
                        this.sourceUrl = window.URL.createObjectURL(new Blob([response.data]));
                        this.isLoading = false;
                    }
                }
            }
        },
        async handleIniData() {
            this.type = null;
            this.sourceUrl = '';
            this.title = '';
            this.hasPermission = true;

            /* Data can be from upload component or fromt document api or from detail-recent-items
             * if from upload compontent: .src and .type is provided
             * if file-object: got fileId etc...
             * if recent-object: got .meta and .id
             */
            if (this.data.fileId) {
                this.processDocument(this.data);
            } else if (this.data.meta && this.data.id) {
                //RECENT-OBJECT
                if (this.data.meta.parentIds && this.data.meta.parentIds.length > 0) {
                    var result = await this.$store.dispatch('GET_DOCUMENT', {
                        id: this.data.id,
                        nodeId: this.data.meta.parentIds[0],
                    });
                    this.data = result;
                    this.processDocument(result);
                }
            } else {
                //UPLOAD-OBJECT
                this.type = this.data.type;
                this.title = this.data.name;
                if (this.data.src) {
                    this.sourceUrl = this.data.src;
                }
            }
        },
        doClick() {
            if (this.addClick) {
                this.$emit('click', this.data);
            }
        },
    },
};
</script>
